import { Injectable } from "@angular/core";
import { Firestore, collection, collectionData } from "@angular/fire/firestore";
import { Observable, lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import {Interest} from '../models/interest.model';

@Injectable({
  providedIn: 'root',
})
export class InterestsService {
  constructor(
    public afs: Firestore
  ) { }

   getInterests() {
   
    return collectionData( collection(this.afs,"interests")).pipe(map(data=>{
      const interests: Interest[] = [];
      data.forEach(qr => {
        const session = this.getInterestObj(qr);
        interests.push(session);
      });
      return interests;
    }));
   
  }

  getInterestsObserverable(): Observable<any> {
    return collectionData( collection(this.afs,"interests"));
  }

  getInterestObj(qr) {
    const interest = new Interest();
    interest.id = qr.id;
    interest.interest = qr.interest;
    interest.focuses = qr.focuses;
    return interest;
  }
}

